import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { QuestionType } from "./useGetMyQuestions";
import { useGetMySummary } from "./useGetMySummary";

// Based on prisma schema

interface QuestionDetails {
  id: number;
  slug: string;
  title: string;
  category: string;
  questionType: QuestionType;
}

interface SelectedOptionDetails {
  id: number;
  displayText: string;
  value?: string | null;
}

interface SelectedOptionContainer {
  option: SelectedOptionDetails;
}

export interface GetMyPersonalityTestAnswersDto {
  id: number;
  questionId: number;
  answerText?: string | null;
  answerScale?: number | null;
  question: QuestionDetails;
  selectedOptions: SelectedOptionContainer[];
}

const GET_ANSWERS_URL = "api/personality-test/me/answers";

const getMyPersonalityTestAnswers = async (): Promise<GetMyPersonalityTestAnswersDto[]> => {
  const response = await apiFetch(GET_ANSWERS_URL, {
    method: "GET",
    // Assuming apiFetch handles auth headers automatically
  });

  if (!response.ok) {
    const errorBody = await response.text();
    console.error("Error fetching personality answers:", errorBody);
    throw new Error("취향 테스트 답변을 불러오지 못했습니다.");
  }

  return response.json();
};

export const useMyPersonalityTestAnswers = () => {
  const { data: user } = useGetMySummary();
  return useQuery({
    queryKey: ["myPersonalityTestAnswers", user?.uid],
    queryFn: getMyPersonalityTestAnswers,
  });
};
